import styled from 'styled-components';

import { tokens } from '../../tokens';

export const NftListWrapper = styled.div`
    padding-bottom: ${tokens.list.wrapper.padding.bottom}px;
`;

// TODO: This is copied from (and should be consolidated):
export const Pagination = styled.div`
    margin-top: ${tokens.list.pagination.margin.top}px;
    width: 100%;
    text-align: center;
`;
